import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Loader, Modal, ModalHandle, TasksStore } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppStore } from '../Core/AppStore';
import { DisplayListViewModel } from '../DisplayFilters/DisplayListViewModel';
import { ManageDisplayListCard } from '../Displays/ManageDisplayListCard';
import { AdminStore } from './AdminStore';

export interface IWebApiSettingsProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class WebApiSettings extends React.Component<IWebApiSettingsProps> {
    public constructor(props: IWebApiSettingsProps) {
        super(props);

        this.vm = new DisplayListViewModel({
            columns: [{ option: 'Serial Number' }, { option: 'Unit Serial Number' }, { option: 'WebApi Kicks' }],
            removeCheckedOnChange: false,
        });
    }

    @action
    public async componentDidMount() {
        this.loading = true;
        try {
            await this.vm.loadMoreAsync();
            await this.vm.loadContractsAsync();
        } catch (e: any) {
            this.appStore.setError(e);
        }

        this.loading = false;
    }

    public render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-9">
                        <ManageDisplayListCard vm={this.vm} title="All Displays" height={800} renderDisplayFilter />
                    </div>
                    <div className="col-3 card pt-2">
                        <div className="d-flex justify-content-between">
                            <a className="btn btn-primary" onClick={this.onEnableWebApiKicks}>
                                Enable Kicks
                            </a>

                            <a className="btn btn-primary" onClick={this.onDisableWebApiKicks}>
                                Disable Kicks
                            </a>
                        </div>
                        <div
                            className="card-body p-0"
                            ref={this.setSerialListContainer}
                            style={{ overflowY: 'auto', height: 800 }}
                        >
                            {this.vm.checkedSerialNumbers.map(s => (
                                <div key={s}>{s}</div>
                            ))}
                        </div>
                    </div>
                </div>
                <Modal
                    className="modal-sm"
                    title={this.actionState + ' Kicks for the following Displays?'}
                    modalHandle={this.modalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    {this.vm.checkedSerialNumbers.map(s => (
                        <div key={s}>{s}</div>
                    ))}
                </Modal>
            </div>
        );
    }

    @bind
    @action
    private setSerialListContainer(r: HTMLDivElement | null) {
        this.serialListContainer = r;
    }

    @bind
    @action
    private async onEnableWebApiKicks() {
        this.actionState = 'Enable';

        if (await this.modalHandle.confirm()) {
            const task = this.tasksStore.startSessionTask(`Enable WebApi Kicks`);

            try {
                await this.adminStore.enableKicks(this.vm.checkedSerialNumbers);
                task.complete();
            } catch (e) {
                task.error(e);
            } finally {
                await this.vm.reloadAsync();
            }
        }
    }

    @bind
    @action
    private async onDisableWebApiKicks() {
        this.actionState = 'Disable';

        if (await this.modalHandle.confirm()) {
            const task = this.tasksStore.startSessionTask(`Disable WebApi Kicks`);

            try {
                await this.adminStore.disableKicks(this.vm.checkedSerialNumbers);
                task.complete();
            } catch (e) {
                task.error(e);
            } finally {
                await this.vm.reloadAsync();
            }
        }
    }

    @observable
    private loading: boolean = false;
    @observable
    private actionState: 'Enable' | 'Disable' = 'Enable';
    @inject
    private adminStore!: AdminStore;
    @inject
    private appStore!: AppStore;
    @inject
    private tasksStore!: TasksStore;
    private serialListContainer: HTMLDivElement | null = null;
    private vm: DisplayListViewModel;
    private modalHandle = new ModalHandle();
}
